import Types from './types';

let GlobalDispatch = () => null;

export const SetDispatch = (e) => {
  GlobalDispatch = e;
};

export const dispatchSaveData = (data) =>
  GlobalDispatch({ type: Types.SaveData, data });

export const SaveData = (data) => ({ type: Types.SaveData, data });
